"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWITCH_VIEW_MODE_REQUESTED = void 0;
exports.SWITCH_VIEW_MODE_REQUESTED = "SWITCH_VIEW_MODE_REQUESTED";
function default_1(viewMode) {
    return (dispatch, getState) => {
        const selectedChatIndex = getState().chatsState.selectedChatIndex;
        const event = {
            type: exports.SWITCH_VIEW_MODE_REQUESTED,
            payload: {
                viewMode,
                isChatSelected: selectedChatIndex != null
            }
        };
        dispatch(event);
    };
}
exports.default = default_1;
